export default __webpack_public_path__ + "static/media/key.119add17.png";